import React from 'react';
import { TextStatus, ToolkitFeatureFlag } from '@cko/primitives';
import { OffsetText, OffsetTextContainer } from './TimeZoneOffset.styles';
export const TimeZoneOffset = (props) => (React.createElement(ToolkitFeatureFlag, { flag: "v10" },
    React.createElement(TextStatus, { marginLeft: "var(--layout-seed)", minWidth: "74px", maxHeight: "20px" },
        React.createElement(OffsetTextContainer, null,
            React.createElement(OffsetText, null,
                "UTC",
                props.utcOffsetString)))));
